import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iis-volume',
  templateUrl: './iis-volume.component.html',
  styleUrls: []
})
export class IisVolumeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
